<template>
  <div class="content">
    <div :class="{ 'date-and-time': displayDateAndTimes }">
      <template v-if="onlyShowStartAndEndDates">
        <DateRangeDetails :start-date="event.startAt" :end-date="event.endAt" />
      </template>
      <template v-else>
        <DateDetails class="date" :date="event.startAt" />
        <template v-if="showEndTime">
          <TimeRangeDetails class="time" :start-date="event.startAt" :end-date="event.endAt" :time-zone="timeZone" />
        </template>
        <template v-else>
          <TimeDetails class="time" :date="event.startAt" :time-zone="timeZone" />
        </template>
      </template>
    </div>
    <LocationDetailsWithIcon v-if="isLocal" :location="event.location" :venue="event.locationVenue" :hide-exact-location="event.hiddenAddress" />
    <VirtualEventDetailsWithIcon v-if="event.virtual" />
    <stat-with-icon v-if="showAttendeesCount" icon-class="icon-users" :number="event.attendeesCount" label-i18n-key="activerecord.models.attendee" />
  </div>
</template>

<script>
import LocationDetailsWithIcon from '../components/location-details-with-icon'
import DateDetails from '../components/date-details'
import DateRangeDetails from '../components/date-range-details'
import StatWithIcon from '../stats/stat-with-icon'
import TimeDetails from '../components/time-details'
import TimeRangeDetails from '../components/time-range-details'
import VirtualEventDetailsWithIcon from '../components/virtual-event-details-with-icon'
import { isMultiDayEvent } from '../helpers/event'
import isPresent from '../helpers/is-present'

const ATTENDEE_COUNT_THRESHOLD = 5

export default {
  components: { DateDetails, DateRangeDetails, LocationDetailsWithIcon,
                StatWithIcon, TimeDetails, TimeRangeDetails, VirtualEventDetailsWithIcon },
  props: {
    event: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      onlyShowStartAndEndDates: isMultiDayEvent(this.event),
      showEndTime: isPresent(this.event.endAt)
    }
  },

  computed: {
    displayDateAndTimes() {
      return !this.onlyShowStartAndEndDates
    },
    isLocal() {
      return this.event.location
    },
    showAttendeesCount() {
      return this.event.attendeesCount > ATTENDEE_COUNT_THRESHOLD
    },
    timeZone() {
      return this.event.startTz
    }
  }
}
</script>

<style lang="scss" scoped>
  @use "~common_styles/breakpoints" as breakpoints;

  .content {
    line-height: 2;
    font-size: 17px;
  }

  .date-and-time {
    display: flex;
    flex-direction: column;

    @include breakpoints.screen-lg-up {
      flex-direction: row;

      .date {
        flex-basis: 225px;
      }

      .time {
        flex: 1;
      }
    }
  }
</style>
